/* GFHQ delivery helpers + cart guard.
   Needs window.GFHQ_DELIVERY (snippets/gfhq-delivery-data.liquid). */
(function () {
  if (window.GFHQD) return;
  var D = window.GFHQ_DELIVERY || {};

  function hav(lat1, lon1, lat2, lon2) {
    var R = 3958.8, r = Math.PI / 180;
    var a = Math.pow(Math.sin((lat2 - lat1) * r / 2), 2) +
      Math.cos(lat1 * r) * Math.cos(lat2 * r) * Math.pow(Math.sin((lon2 - lon1) * r / 2), 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  function lookupZip(zip) {
    return fetch('https://api.zippopotam.us/us/' + zip)
      .then(function (r) { if (!r.ok) throw new Error('zip'); return r.json(); })
      .then(function (j) {
        var p = j.places && j.places[0];
        if (!p) throw new Error('zip');
        return { place: p['place name'], st: p['state abbreviation'], lat: +p.latitude, lng: +p.longitude };
      });
  }

  function nearestHub(lat, lng) {
    var best = null;
    (D.hubs || []).forEach(function (h) {
      var d = hav(h.lat, h.lng, lat, lng);
      if (!best || d < best.d) best = { hub: h, d: d };
    });
    return best ? { hub: best.hub, miles: Math.max(1, Math.ceil(best.d * (D.road || 1.2))) } : null;
  }

  function pad4(n) { n = String(n); while (n.length < 4) n = '0' + n; return n; }

  /* Returns { sku, id, price (cents), billedMiles } or null if out of range. */
  function deliveryVariant(miles) {
    var step = D.step || 10;
    /* 10-mile steps up to D.longFrom miles, then D.longStep-mile steps (keeps the product under 250 variants) */
    if (D.longFrom && miles > D.longFrom) step = D.longStep || 20;
    var billed = Math.max(step, Math.ceil(miles / step) * step);
    if (billed > (D.maxMiles || 1500)) return null;
    var sku = 'GFHQ-DEL-' + pad4(billed);
    var v = (D.variants || {})[sku];
    return v ? { sku: sku, id: v[0], price: v[1], billedMiles: billed } : null;
  }

  /* START Freight Shipping (crated). svc = 'T' terminal, 'B' business, 'R' residential; lift = liftgate;
     crates = 2 for 4x8 / 4x10 / 5x10 kits (uses the 2-crate price list, $250 more).
     Returns { sku, id, price (cents), billedMiles } or null if out of range. */
  function freightVariant(miles, svc, lift, crates) {
    var F = D.freight || {};
    var step = F.step || 100;
    var billed = Math.max(step, Math.ceil(miles / step) * step);
    if (billed > (F.maxMiles || 3200)) return null;
    var code = svc + (lift && svc !== 'T' ? 'L' : '');
    var sku = (crates === 2 ? 'GFHQ-FRT2-' : 'GFHQ-FRT-') + pad4(billed) + '-' + code;
    var v = (D.variants || {})[sku];
    return v ? { sku: sku, id: v[0], price: v[1], billedMiles: billed } : null;
  }

  /* Second crate for the large START kits. options = the machine variant's option values (array of strings). */
  function needsSecondCrate(options) {
    var sc = (D.freight || {}).secondCrate;
    if (!sc || !options) return false;
    return options.some(function (o) { return sc.sizes.indexOf(o) > -1; });
  }
  function secondCrateVariant() { return null; } /* retired: the crate fee is built into the 2-crate price list */
  function preassemblyVariant() {
    var pa = D.preassembly;
    var v = pa && (D.variants || {})[pa.sku];
    return v ? { sku: pa.sku, id: v[0], price: v[1] } : null;
  }

  function isFreightMachine(handle) {
    return ((D.freight || {}).prefixes || []).some(function (p) { return handle && handle.indexOf(p) === 0 && handle.indexOf('-biy-') === -1; });
  }

  function isDeliveryLine(handle) {
    var F = D.freight || {};
    return !!handle && (handle === D.handle || handle === F.handle || handle === F.handle2 || handle === (D.preassembly || {}).handle);
  }

  function pickupVariant(hub) {
    var v = (D.variants || {})[hub.pickup];
    return v ? { sku: hub.pickup, id: v[0], price: v[1] } : null;
  }

  function money(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function isMachine(handle) {
    return (D.machinePrefixes || []).some(function (p) { return handle && handle.indexOf(p) === 0 && handle.indexOf('-biy-') === -1; });
  }

  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    });
  }

  function removeDeliveryLines(cart) {
    var updates = {};
    cart.items.forEach(function (it) { if (isDeliveryLine(it.handle)) updates[it.key] = 0; });
    if (!Object.keys(updates).length) return Promise.resolve(cart);
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  /* Cart state: which machine (if any) still needs a delivery / pickup line. */
  function cartState(cart) {
    var machine = null, hasDelivery = false;
    cart.items.forEach(function (it) {
      if (isDeliveryLine(it.handle)) hasDelivery = true;
      else if (!machine && isMachine(it.handle)) machine = it;
    });
    return { machine: machine, hasDelivery: hasDelivery, needs: !!machine && !hasDelivery, orphan: !machine && hasDelivery };
  }

  window.GFHQD = {
    data: D, lookupZip: lookupZip, nearestHub: nearestHub, deliveryVariant: deliveryVariant,
    freightVariant: freightVariant, isFreightMachine: isFreightMachine, isDeliveryLine: isDeliveryLine,
    needsSecondCrate: needsSecondCrate, secondCrateVariant: secondCrateVariant, preassemblyVariant: preassemblyVariant,
    pickupVariant: pickupVariant, money: money, getCart: getCart, addItems: addItems,
    removeDeliveryLines: removeDeliveryLines, cartState: cartState, isMachine: isMachine
  };

  /* ---------- Ride-along: accessories ship free ONLY with START Freight or GFHQ Direct delivery ----------
     A free-shipping discount code (D.rideCode, min subtotal $4,999) is added to the cart when the cart has a
     freight / GFHQ Direct delivery line plus parcel items, and removed otherwise (pickup orders pay parcel). */
  var RIDE = (D.rideCode || 'MACHINE-RIDEALONG').toUpperCase();
  function isShipLine(it) {
    var F = D.freight || {};
    if (it.handle === F.handle || it.handle === F.handle2) return true;
    return it.handle === D.handle && !!it.sku && it.sku.indexOf('GFHQ-PICKUP') !== 0;
  }
  function isParcelItem(it) { return it.requires_shipping && !isMachine(it.handle) && !isDeliveryLine(it.handle); }
  function syncRide(cart) {
    var want = cart.items.some(isShipLine) && cart.items.some(isParcelItem);
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    var has = codes.some(function (c) { return String(c).toUpperCase() === RIDE; });
    if (want === has) return Promise.resolve({ cart: cart, changed: false });
    var next = codes.filter(function (c) { return String(c).toUpperCase() !== RIDE; });
    if (want) next.push(RIDE);
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: next.join(',') })
    }).then(function (r) { return r.json(); }).then(function (c) { return { cart: c, changed: true }; });
  }
  window.GFHQD.syncRide = syncRide;

  /* ---------- Cart guard: START / CORE / PRO machines need delivery, freight or pickup before checkout ---------- */
  function fixUrl(machine) {
    return '/products/' + machine.handle + '?gfhq_delivery_only=1#gfhq-delivery';
  }

  function markCart() {
    getCart().then(function (cart) {
      var s = cartState(cart);
      document.documentElement.classList.toggle('gfhq-needs-delivery', s.needs);
      var banners = document.querySelectorAll('[data-gfhq-cart-banner]');
      Array.prototype.forEach.call(banners, function (b) {
        b.hidden = !s.needs;
        var a = b.querySelector('a');
        if (a && s.machine) a.href = fixUrl(s.machine);
      });
      if (s.orphan) { removeDeliveryLines(cart).then(getCart).then(syncRide); return; }
      syncRide(cart).then(function (r) {
        if (r.changed && /^\/cart\/?$/.test(location.pathname) && !sessionStorage.getItem('gfhq_ride_reload')) {
          try { sessionStorage.setItem('gfhq_ride_reload', '1'); } catch (e) {}
          location.reload();
        } else { try { sessionStorage.removeItem('gfhq_ride_reload'); } catch (e) {} }
      });
    }).catch(function () {});
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"], [data-gfhq-checkout]');
  }

  var passing = false;
  function guard(e, trigger) {
    if (passing) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    getCart().then(function (cart) {
      var s = cartState(cart);
      if (s.needs) { window.location.href = fixUrl(s.machine); return; }
      var go = function () { passing = true; window.location.href = '/checkout'; };
      var sync = function () { return getCart().then(syncRide).catch(function () {}); };
      if (s.orphan) removeDeliveryLines(cart).then(sync).then(go); else syncRide(cart).catch(function () {}).then(go);
    }).catch(function () { passing = true; window.location.href = '/checkout'; });
  }

  document.addEventListener('click', function (e) {
    var t = isCheckoutTrigger(e.target);
    if (t) guard(e, t);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') return guard(e, sub);
    if (f && f.getAttribute && /\/checkout/.test(f.getAttribute('action') || '')) guard(e, f);
  }, true);

  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(markCart, 150); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markCart); else markCart();
  window.addEventListener('pageshow', markCart);
})();
